export default "__VITE_ASSET__By5zXNw7__"